<div *ngIf="isLoading$ === true; else completedBlock">
    <mat-spinner diameter="80" class="mx-auto"></mat-spinner>
  </div>
  <ng-template #completedBlock>
          <div fxLayout="row" fxLayoutAlign="start start" class="full-height">
            <div class="reports_container">
                
                <div fxLayout="column" fxLayoutGap="16px" class="product_reports_container report_container">
                    <mat-card class="main-card " fxFlex="100">
                        <mat-card-content class="report_container_list">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="left left">
                                    <h4 class="font-bold text-base">{{"report.totalonhand.title"|translate}}</h4>
                                    <span class="report_description">{{"report.totalonhand.desc"|translate}}</span>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <a mat-raised-button color="primary" routerLink="/reports/products-total-onhand">View</a>
                                </div>
                            </div>
                            
                            <hr class="bt_line">

                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="left left">
                                    <h4 class="font-bold text-base">{{"report.picked.title"|translate}}</h4>
                                    <span class="report_description">{{"report.picked.desc"|translate}}</span>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <a mat-raised-button color="primary" routerLink="/reports/picked">View</a>
                                </div>
                            </div>

                            <hr class="bt_line">

                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="left left">
                                    <h4 class="font-bold text-base">{{"report.pickActivity.title"|translate}}</h4>
                                    <span class="report_description">{{"report.pickActivity.desc"|translate}}</span>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <a mat-raised-button color="primary" routerLink="/reports/pick-activity">View</a>
                                </div>
                            </div>

                            <hr class="bt_line">

                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="left left">
                                    <h4 class="font-bold text-base">{{"report.received.title"|translate}}</h4>
                                    <span class="report_description">{{"report.received.desc"|translate}}</span>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <a mat-raised-button color="primary" routerLink="/reports/received">View</a>
                                </div>
                            </div>

                            <hr class="bt_line">

                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="left left">
                                    <h4 class="font-bold text-base">{{"report.reorder.title"|translate}}</h4>
                                    <span class="report_description">{{"report.reorder.desc"|translate}}</span>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center center">
                                    <a mat-raised-button color="primary" routerLink="/reports/re-order">View</a>
                                </div>
                            </div>

                            <!-- Asset Check-Outs Report - Only visible when Asset Module is enabled -->
                            <ng-container *ngIf="locUsesAssetModule === 1">
                                <hr class="bt_line">

                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="column" fxLayoutAlign="left left">
                                        <h4 class="font-bold text-base">{{"report.assets.title"|translate}}</h4>
                                        <span class="report_description">{{"report.assets.desc"|translate}}</span>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <a mat-raised-button color="primary" routerLink="/reports/assets">View</a>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Serialized products report (T-317) - Only visible when Serialized Module is enabled -->
                            <ng-container *ngIf="locUsesSerializedModule === 1">
                                <hr class="bt_line">

                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="column" fxLayoutAlign="left left">
                                        <h4 class="font-bold text-base">{{"report.serialized.title"|translate}}</h4>
                                        <span class="report_description">{{"report.serialized.desc"|translate}}</span>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <a mat-raised-button color="primary" routerLink="/reports/serialized">View</a>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Product Serial Numbers Report - Only visible when Serialized Module is enabled -->
                            <ng-container *ngIf="locUsesSerializedModule === 1">
                                <hr class="bt_line">

                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div fxLayout="column" fxLayoutAlign="left left">
                                        <h4 class="font-bold text-base">{{"report.serialNumbers.title"|translate}}</h4>
                                        <span class="report_description">{{"report.serialNumbers.desc"|translate}}</span>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="center center">
                                        <a mat-raised-button color="primary" routerLink="/reports/products/product-serial-number">View</a>
                                    </div>
                                </div>
                            </ng-container>

                        </mat-card-content>
                    </mat-card>
                </div>

                


            </div>
          </div>
  </ng-template>